 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML01_HALF from '@/components/xhtml/01_Half'
 import XHTML01A_FM from '@/components/xhtml/01a_Fm'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML02_TITLE from '@/components/xhtml/02_Title'
 import XHTML02A_COPYRIGHT from '@/components/xhtml/02a_Copyright'
 import XHTML03_DEDI from '@/components/xhtml/03_Dedi'
 import XHTML04_PRAISE from '@/components/xhtml/04_Praise'
 import XHTMLTOC from '@/components/xhtml/Toc'
 import XHTML05_ILLUSTRATIONS from '@/components/xhtml/05_Illustrations'
 import XHTML06_FOREWORD from '@/components/xhtml/06_Foreword'
 import XHTML07_ACKNOWLEDGMENTS from '@/components/xhtml/07_Acknowledgments'
 import XHTML08_INTRODUCTION from '@/components/xhtml/08_Introduction'
 import XHTML09_CHAPTER01 from '@/components/xhtml/09_Chapter01'
 import XHTML10_CHAPTER02 from '@/components/xhtml/10_Chapter02'
 import XHTML11_CHAPTER03 from '@/components/xhtml/11_Chapter03'
 import XHTML12_CHAPTER04 from '@/components/xhtml/12_Chapter04'
 import XHTML13_CHAPTER05 from '@/components/xhtml/13_Chapter05'
 import XHTML14_CHAPTER06 from '@/components/xhtml/14_Chapter06'
 import XHTML15_CHAPTER07 from '@/components/xhtml/15_Chapter07'
 import XHTML15_CHAPTER07A from '@/components/xhtml/15_Chapter07a'
 import XHTML16_CHAPTER08 from '@/components/xhtml/16_Chapter08'
 import XHTML16_CHAPTER08A from '@/components/xhtml/16_Chapter08a'
 import XHTML17_CHAPTER09 from '@/components/xhtml/17_Chapter09'
 import XHTML17_CHAPTER09A from '@/components/xhtml/17_Chapter09a'
 import XHTML18_CHAPTER10 from '@/components/xhtml/18_Chapter10'
 import XHTML19_CHAPTER11 from '@/components/xhtml/19_Chapter11'
 import XHTML20_CHAPTER12 from '@/components/xhtml/20_Chapter12'
 import XHTML21_CHAPTER13 from '@/components/xhtml/21_Chapter13'
 import XHTML21_CHAPTER13A from '@/components/xhtml/21_Chapter13a'
 import XHTML22_CHAPTER14 from '@/components/xhtml/22_Chapter14'
 import XHTML23_CONCLUDING from '@/components/xhtml/23_Concluding'
 import XHTML24_EPILOGUE from '@/components/xhtml/24_Epilogue'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML25_APPENDIX1 from '@/components/xhtml/25_Appendix1'
 import XHTML26_APPENDIX2 from '@/components/xhtml/26_Appendix2'
 import XHTML27_APPENDIX3 from '@/components/xhtml/27_Appendix3'
 import XHTML28_NOTES from '@/components/xhtml/28_Notes'
 import XHTML28_NOTESA from '@/components/xhtml/28_Notesa'
 import XHTML28_NOTESB from '@/components/xhtml/28_Notesb'
 import XHTML29_REFERENCES from '@/components/xhtml/29_References'
 import XHTML30_INDEX from '@/components/xhtml/30_Index'
 import XHTML30_INDEXA from '@/components/xhtml/30_Indexa'
 import XHTML30_INDEXB from '@/components/xhtml/30_Indexb'
 import XHTML30_INDEXC from '@/components/xhtml/30_Indexc'
 import XHTML30_INDEXD from '@/components/xhtml/30_Indexd'
 import XHTML30_INDEXE from '@/components/xhtml/30_Indexe'
 import XHTML30_INDEXF from '@/components/xhtml/30_Indexf'
 import XHTML30_INDEXG from '@/components/xhtml/30_Indexg'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/01_Half",
 			"name" : "xhtml/01_Half",
 			"component" : XHTML01_HALF
 		},
 		{
 			"path" : "/xhtml/01a_Fm",
 			"name" : "xhtml/01a_Fm",
 			"component" : XHTML01A_FM
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/02_Title",
 			"name" : "xhtml/02_Title",
 			"component" : XHTML02_TITLE
 		},
 		{
 			"path" : "/xhtml/02a_Copyright",
 			"name" : "xhtml/02a_Copyright",
 			"component" : XHTML02A_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/03_Dedi",
 			"name" : "xhtml/03_Dedi",
 			"component" : XHTML03_DEDI
 		},
 		{
 			"path" : "/xhtml/04_Praise",
 			"name" : "xhtml/04_Praise",
 			"component" : XHTML04_PRAISE
 		},
 		{
 			"path" : "/xhtml/Toc",
 			"name" : "xhtml/Toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/05_Illustrations",
 			"name" : "xhtml/05_Illustrations",
 			"component" : XHTML05_ILLUSTRATIONS
 		},
 		{
 			"path" : "/xhtml/06_Foreword",
 			"name" : "xhtml/06_Foreword",
 			"component" : XHTML06_FOREWORD
 		},
 		{
 			"path" : "/xhtml/07_Acknowledgments",
 			"name" : "xhtml/07_Acknowledgments",
 			"component" : XHTML07_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/08_Introduction",
 			"name" : "xhtml/08_Introduction",
 			"component" : XHTML08_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/09_Chapter01",
 			"name" : "xhtml/09_Chapter01",
 			"component" : XHTML09_CHAPTER01
 		},
 		{
 			"path" : "/xhtml/10_Chapter02",
 			"name" : "xhtml/10_Chapter02",
 			"component" : XHTML10_CHAPTER02
 		},
 		{
 			"path" : "/xhtml/11_Chapter03",
 			"name" : "xhtml/11_Chapter03",
 			"component" : XHTML11_CHAPTER03
 		},
 		{
 			"path" : "/xhtml/12_Chapter04",
 			"name" : "xhtml/12_Chapter04",
 			"component" : XHTML12_CHAPTER04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js